<template>
  <div class="header-section-component">
    <div class="columns">
      <div class="column is-12">
        <p class="is-size-1 has-text-centered has-text-white dm-sans">
          <span>
            CONTRATAÇÃO REALIZADA COM SUCESSO!
          </span>
        </p>
      </div>
    </div>
    <div class="columns">
      <div class="column is-12">
        <p class="is-size-4 has-text-centered has-text-white dm-sans">
          Agora basta aguardar um instante,
          que em breve serão liberadas as funcionalidades de disparos de campanhas através do PEC para sua loja.
        </p>
      </div>
    </div>
  </div>
</template>

<script>

export default {

  name: 'header-section'

}

</script>